import { useAuth } from "@/context/AuthContext";
import { instanceName } from "./country";
import { cabinetDisplayName } from "@/lib/wording";

export default function CountryBar() {
  const { cabinet } = useAuth();
  return <header className="h-14 shrink-0 border-b border-border bg-card flex items-center justify-between gap-3 px-4" data-testid="country-bar">
    <span className="font-heading text-sm font-semibold truncate">{instanceName()} <span className="hidden sm:inline text-muted-foreground font-normal">· {cabinetDisplayName(cabinet)}</span></span>
  </header>;
}
